'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./enums-de2d9d36.js');
var progressBar = require('./progress-bar-cfb02ff8.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  font-family: ", ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: ", ";\n  z-index: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  font-family: ", ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: ", ";\n  z-index: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, constants.ZINDEX.MODAL_BACKGROUND);
var TopHeader = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  box-shadow: 0px 4px 4px -4px ", ";\n  width: 100%;\n  ", "\n"], ["\n  box-shadow: 0px 4px 4px -4px ", ";\n  width: 100%;\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorsRgba.universalBlack_1;
}, function (_a) {
    var isShowProgress = _a.isShowProgress;
    return isShowProgress && "\n    box-shadow: none;\n    padding-bottom: 0;\n  ";
});
var StyledProgressBar = styled__default(progressBar.ProgressBar)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  height: 3px;\n  margin: 0 -18px;\n"], ["\n  height: 3px;\n  margin: 0 -18px;\n"])));
var HqoQuestionHeader = function (_a) {
    var currentStep = _a.currentStep, dataTestId = _a.dataTestId, _b = _a.showProgressBar, showProgressBar = _b === void 0 ? false : _b, totalSteps = _a.totalSteps;
    return (React__default.createElement(Container, { "data-testid": dataTestId },
        React__default.createElement(TopHeader, { isShowProgress: showProgressBar }, (showProgressBar && currentStep && totalSteps)
            && React__default.createElement(StyledProgressBar, { width: (currentStep / totalSteps) * 100 }))));
};
var templateObject_1, templateObject_2, templateObject_3;

exports.HqoQuestionHeader = HqoQuestionHeader;
